module.exports = __webpack_public_path__ + "img/noti.1b5d9f0d.svg";